import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyC6ZNAQAP1YhxhynZ3k9N1g0NwlLtn5QsI",
    authDomain: "sales-boosting-bb.firebaseapp.com",
    projectId: "sales-boosting-bb",
    storageBucket: "sales-boosting-bb.appspot.com",
    messagingSenderId: "416173463280",
    appId: "1:416173463280:web:e4d96b33612132c7e15435"
  }

firebase.initializeApp(firebaseConfig)

export const FieldValue = firebase.firestore.FieldValue
export const FieldPath = firebase.firestore.FieldPath
export const db = firebase.firestore()
global.db = db
export const auth = firebase.auth()
export const storage = firebase.storage()
export const functions = firebase.app().functions()
global.functions = functions